import { TableCell } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const StyledTableCell = withStyles(() => ({
    body: { color: 'inherit' },
}))(TableCell);

export default StyledTableCell;
